import { all, put, call, getContext, takeLatest } from 'redux-saga/effects';

import { Logger } from 'utils/Logger';

import { conversationsData } from './types';

import { requestConversationsDataSuccess, requestConversationsDataFailure } from './reducer';

const logger = new Logger('Saga:Monitor');

export function* requestConversationsData(action) {
  const authApiService = yield getContext('authApiService');
  const routerService = yield getContext('routerService');

  try {
    const response = yield call(
      authApiService.get,
      routerService.generate('api.monitor.conversations', { entityId: action.entityId }),
    );
    yield put(
      requestConversationsDataSuccess(response.data.map(({ conversation }) => conversation)),
    );
  } catch (error) {
    logger.info('Failed to get clients conversations', error);
    yield put(requestConversationsDataFailure(error));
  }
}

export default function* conversationsSaga() {
  return yield all([takeLatest(conversationsData.request, requestConversationsData)]);
}
